import { _patientUrls } from '@custom/Utils/constants/apiUrls';
import { createAsyncThunk } from '@reduxjs/toolkit';

const prescriptionDelete = createAsyncThunk('prescriptionDelete', async (data: any) => {
  try {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    let url = _patientUrls.prescriptionDelete
    let response = await fetch(url, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (error) {
    return error;
  }
});

export default prescriptionDelete;
